module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-portal-list"
  }, [_c('rt-sass-grid', {
    ref: "grid",
    attrs: {
      "iconName": "rt-portal-order-form",
      "title": _vm.$_t('签核处理', 'approval.flowapproval'),
      "quicksearch-placeholder": _vm.$_t('请输入单号', 'common.plsenterno'),
      "totalRecord": _vm.dataTotalCount,
      "currentPageIndex": _vm.currentPageIndex,
      "currentPageSize": _vm.currentPageSize
    },
    on: {
      "page-change": _vm.handlePageChange,
      "quick-search": _vm.handleSearch,
      "search": _vm.handleSearch,
      "reset": _vm.handleReset
    }
  }, [_c('template', {
    slot: "more"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "model": _vm.queryForm,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40,
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('申请人', 'new_flowapprovalcrf.new_applyuser'),
      "prop": "submitUser"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$_t('申请人', 'new_flowapprovalcrf.new_applyuser'),
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.submitUser),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "submitUser", $$v)
      },
      expression: "queryForm.submitUser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('部门管理', 'crm.businessunit'),
      "prop": "businessName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$_t('部门管理', 'crm.businessunit'),
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.businessName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "businessName", $$v)
      },
      expression: "queryForm.businessName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('摘要', 'new_flowapprovalcrf.new_memo'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$_t('摘要', 'new_flowapprovalcrf.new_memo'),
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "memo", $$v)
      },
      expression: "queryForm.memo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40,
      "type": "flex"
    }
  }, [(_vm.activeName == 'first' || _vm.activeName == 'first_reject') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('申请时间', 'new_flowapprovalcrf.new_applydate'),
      "prop": "applyDate"
    }
  }, [_c('el-date-picker', {
    staticClass: "rt-portal-item-date",
    attrs: {
      "format": "yyyy/MM/dd",
      "start-placeholder": _vm.$_t('开始日期', 'daterange.begindate'),
      "end-placeholder": _vm.$_t('结束日期', 'daterange.enddate'),
      "type": "daterange"
    },
    on: {
      "change": _vm.applydatechange
    },
    model: {
      value: (_vm.queryForm.applyDate),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "applyDate", $$v)
      },
      expression: "queryForm.applyDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeName == 'second') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('签核时间',
        'new_flowapproval_steps.new_approvedate'),
      "prop": "approveDate"
    }
  }, [_c('el-date-picker', {
    staticClass: "rt-portal-item-date",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": _vm.$_t('签核时间',
        'new_flowapproval_steps.new_approvedate'),
      "type": "date"
    },
    model: {
      value: (_vm.queryForm.approveDate),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "approveDate", $$v)
      },
      expression: "queryForm.approveDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeName == 'second') ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$_t('签核结果',
        'new_flowapproval_steps.new_actiontypename'),
      "prop": "actionType"
    }
  }, [_c('picklistcomponent', {
    attrs: {
      "optionModel": _vm.actionTypeOption,
      "selected": _vm.selectedActionType
    },
    on: {
      "selectitem": _vm.selectActionType
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    ref: "user",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    key: _vm.inApprovedCount + '_first',
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.inApprovedCount > 0) ? _c('b', {
    staticClass: "tabs_num"
  }, [_vm._v(_vm._s(_vm.inApprovedCount))]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$_t("待我审批", "approval.approving")) + "\n        ")]), _vm._v(" "), (_vm.activeName == 'first') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "gridTable",
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "tooltip-effect": "dark"
    },
    on: {
      "row-dblclick": _vm.handleViewDetail,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$_t('表单编号', 'new_flowapprovalcrf.new_formname'),
      "prop": "new_formname",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "worknum",
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.new_formname))])]
      }
    }], null, false, 3772036510)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_flowidName",
      "label": _vm.$_t('签核流程', 'new_flowapprovalcrf.new_flowidname')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_approveuserName",
      "label": _vm.$_t('签核用户', 'new_flowapprovalcrf.owneridname')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_memo",
      "width": "200",
      "label": _vm.$_t('摘要', 'new_flowapprovalcrf.new_memo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_applyuserName",
      "label": _vm.$_t('申请人', 'new_flowapprovalcrf.new_applyuser')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessunitName",
      "label": _vm.$_t('部门管理', 'crm.businessunit'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_applydate",
      "label": _vm.$_t('申请时间', 'new_flowapprovalcrf.new_applydate'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_last_approve_time",
      "width": "160",
      "label": _vm.$_t(
        '上一步审批时间',
        'new_flowapprovalcrf.new_last_approve_time'
      )
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$_t('操作', 'common.operations'),
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$_t("去审批", "approval.doapproval")))])]
      }
    }], null, false, 1884144535)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    key: _vm.ApprovedCount + '_second',
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.ApprovedCount > 0) ? _c('b', {
    staticClass: "tabs_num_success"
  }, [_vm._v(_vm._s(_vm.ApprovedCount))]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$_t("我已审批", "approval.approved")) + "\n        ")]), _vm._v(" "), (_vm.activeName == 'second') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "gridTable",
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-dblclick": _vm.handleViewDetail,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$_t('表单编号', 'new_flowapprovalcrf.new_formname'),
      "prop": "new_formname",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "worknum",
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.new_formname))])]
      }
    }], null, false, 3772036510)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_flowidName",
      "align": "center",
      "label": _vm.$_t('签核流程', 'new_flowapprovalcrf.new_flowidname'),
      "min-width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_approveuserName",
      "align": "center",
      "label": _vm.$_t('签核用户', 'new_flowapprovalcrf.owneridname'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_approvedate",
      "align": "center",
      "label": _vm.$_t('签核时间', 'new_flowapproval_steps.new_approvedate'),
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_actiontypeName",
      "align": "center",
      "label": _vm.$_t('签核结果',
        'new_flowapproval_steps.new_actiontypename'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_applyuserName",
      "align": "center",
      "label": _vm.$_t('申请人', 'new_flowapprovalcrf.new_applyuser'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_memo",
      "width": "200",
      "label": _vm.$_t('摘要', 'new_flowapprovalcrf.new_memo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessunitName",
      "label": _vm.$_t('部门管理', 'crm.businessunit'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$_t('操作', 'common.operations'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$_t("审批详情", "approval.approvaldetail")))])]
      }
    }], null, false, 450642133)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    key: _vm.NotifyCount + '_three',
    attrs: {
      "name": "three"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.NotifyCount > 0) ? _c('b', {
    staticClass: "tabs_num tabs_num3"
  }, [_vm._v(_vm._s(_vm.NotifyCount))]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$_t("知会我的", "approval.notify")) + "\n        ")]), _vm._v(" "), (_vm.activeName == 'three') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "gridTable",
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-dblclick": _vm.handleViewDetail,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$_t('表单编号', 'new_flowapprovalcrf.new_formname'),
      "prop": "new_formname",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "worknum",
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.new_formname))])]
      }
    }], null, false, 3772036510)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_flowidName",
      "label": _vm.$_t('签核流程', 'new_flowapprovalcrf.new_flowidname')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_applyuserName",
      "label": _vm.$_t('申请人', 'new_flowapprovalcrf.new_applyuser')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessunitName",
      "label": _vm.$_t('部门管理', 'crm.businessunit'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_memo",
      "width": "200",
      "label": _vm.$_t('摘要', 'new_flowapprovalcrf.new_memo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_applydate",
      "label": _vm.$_t('申请时间', 'new_flowapprovalcrf.new_applydate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_approvalstatusName",
      "label": _vm.$_t('审批状态', 'new_flowapproval_steps.new_statusname')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$_t('操作', 'common.operations'),
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewDetail(scope.row)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$_t("审批详情", "approval.approvaldetail")))])]
      }
    }], null, false, 450642133)
  })], 1) : _vm._e()], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af84bd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/vflow/ApproveList.vue
// module id = 2017
// module chunks = 228